import {
  Modal,
  ModalBody,
  ModalHeader,
  Button,
  Form,
  FormGroup,
  Label
} from "reactstrap";

import * as React from "react";
import { faCode } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import i18n from "i18n";
import { serialize } from "designer/serializer";
import { DiagramModel } from "storm-react-diagrams";

interface EditJsonState {
  modalOpen: boolean;
  definition: string;
}

interface EditJsonProps {
  onSave: (json: string) => void;
  currentScenarioModel: DiagramModel;
}

export default class EditJson extends React.Component<
  EditJsonProps,
  EditJsonState
> {
  constructor(props: EditJsonProps) {
    super(props);
    this.state = {
      definition: JSON.stringify(serialize(props.currentScenarioModel)),
      modalOpen: false
    };
  }

  componentWillReceiveProps(nextProps: EditJsonProps) {
    this.setState({
      definition: JSON.stringify(serialize(nextProps.currentScenarioModel)),
    });
  }

  render() {
    return (
      <Button color="primary" size="sm" onClick={() => this.toggleModal(true)}>
        <FontAwesomeIcon icon={faCode} />

        <Modal isOpen={this.state.modalOpen}>
          <ModalHeader>{i18n.Designer.Toolbox.EditJson}</ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup>
                <Label>Scenario definition</Label>
                {" "}
                ({this.state.definition.length} / 2000000)
                <textarea
                  className="form-control-sm form-control"
                  rows={10}
                  cols={40}
                  onChange={e => this.update(e)}
                  value={this.state.definition}
                />
              </FormGroup>
            </Form>
            <Button
              color="primary"
              onClick={() => this.onSave()}
            >
              {i18n.Designer.Toolbox.SaveButton}
            </Button>{" "}
            <Button onClick={() => this.toggleModal(false)}>
              {i18n.Global.Close}
            </Button>
          </ModalBody>
        </Modal>
      </Button>
    );
  }

  private update(e: React.ChangeEvent<HTMLTextAreaElement>) {
    this.setState({
      definition: e.target.value,
    });
  }

  private toggleModal(set: boolean) {
    this.setState({
      modalOpen: set
    });
  }

  private onSave() {
    this.setState({
      modalOpen: false,
    });
    this.props.onSave && this.props.onSave(this.state.definition);
  }
}



// WEBPACK FOOTER //
// ./src/designer/edit-json.tsx